// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(min-width: 1024px)";
var _4 = "(max-width: 1024px)";
var _5 = "wrapper-23hhl";
var _6 = "wrapper_business-1nz9J";
var _7 = "cities-J6-gj";
var _8 = "footer__item-2ChQ9";
var _9 = "flightInfo__title-3wG9M";
var _a = "city__airport-TC7tt";
var _b = "flightInfo__value-3a_Fd";
var _c = "city__info-10bg-";
var _d = "city__time-1txuU";
var _e = "plane__icon-2oZ46";
var _f = "flightInfo__item-1MPZx";
var _10 = "footer-8Zq4W";
var _11 = "flightInfo-alNnz";
export { _1 as "__esModule", _2 as "mobile", _3 as "desktop_only", _4 as "tablet", _5 as "wrapper", _6 as "wrapper_business", _7 as "cities", _8 as "footer__item", _9 as "flightInfo__title", _a as "city__airport", _b as "flightInfo__value", _c as "city__info", _d as "city__time", _e as "plane__icon", _f as "flightInfo__item", _10 as "footer", _11 as "flightInfo" }
export default { "__esModule": _1, "mobile": _2, "desktop_only": _3, "tablet": _4, "wrapper": _5, "wrapper_business": _6, "cities": _7, "footer__item": _8, "flightInfo__title": _9, "city__airport": _a, "flightInfo__value": _b, "city__info": _c, "city__time": _d, "plane__icon": _e, "flightInfo__item": _f, "footer": _10, "flightInfo": _11 }
